<div class="mx-1 my-1">
    <div class="row my-row">
        <div class="col-sm my-col">
            <div class="card mt-3">
                <div class="card-header">{{ "DIRECTORY-SHARE.TITLE-SHARE" | translate }}</div>
                <div class="card-body">
                    <app-error [error_message]="errorMessageShared" [error_type]="errorTypeShared"></app-error>
                    <ng-container *ngFor="let share of this.sharedDirectory; let shareIndex = index">
                        <ul>
                            <ng-container>
                                <li class="mx-2 my-2">
                                    <div class="row my-row">
                                        <div class="col my-col">
                                            <span>{{share.name}}</span>
                                        </div>
                                        <div class="col my-col">
                                            <button type="button" class="btn btn-danger btn-sm mx-1" (click)="delete(share)">{{ "BUTTONS.DELETE" | translate }}</button>
                                        </div>
                                    </div>
                                </li>
                            </ng-container>
                        </ul>
                    </ng-container>
                    <form class="form-inline my-2" novalidate="novalidate" (submit)="add(newShare.value)">
                        <div class="form-group">
                            <input #newShare type="text" class="form-control" style="display: inline;" id="newShare" placeholder="{{ 'DIRECTORY-SHARE.PLACEHOLDER' | translate }}">
                            <button type="submit" class="btn btn-primary mx-2">{{ "BUTTONS.ADD" | translate }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="row my-row">
        <div class="col-sm my-col">
            <div class="card mt-3">
                <div class="card-header">{{ "DIRECTORY-SHARE.TITLE-ACCESS" | translate }}</div>
                <div class="card-body">
                    <app-error [error_message]="errorMessageAccess" [error_type]="errorTypeAccess"></app-error>
                    <ng-container *ngIf="this.accessDirectory">
                        <ng-container *ngFor="let access of this.accessDirectory.ps; let accessIndex = index">
                            <ul *ngIf="access.ps != this.userService.currentUser.symfonyUser.id && access.ps != 'all'">
                                <ng-container>
                                    <li class="mx-2 my-2">
                                        <div class="row my-row">
                                            <div class="col my-col">
                                                <app-color-picker [accessDirectory]="access" [heading]="access.name" [color]="access.color"></app-color-picker>
                                            </div>
                                        </div>
                                    </li>
                                </ng-container>
                            </ul>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
